export type ScoreColor = 'success' | 'warning' | 'error' | 'disabled';

export const getScoreColor = (score: number | null): ScoreColor => {
  if (score == null) {
    return 'disabled';
  }
  if (score >= 100) {
    return 'success';
  }
  if (score > 0) {
    return 'warning';
  }
  return 'error';
};
